<div class="container-fluid w-430 pt-4 mb-5">
  <div class="text-center mb-4">
    <h1>
      {{
        "Únete a la Primera Comunidad de Proveedores de Experiencias"
          | translate
      }}
    </h1>
    <!-- <H2> {{'En solo 2 pasos' | translate}}</H2> -->
  </div>

  <!-- Step Indicator -->
  <div class="step-indicator">
    <span [class.current-step]="currentStep === 1">{{
      "Paso 1" | translate
    }}</span>
    <span [class.current-step]="currentStep === 2">{{
      "Paso 2" | translate
    }}</span>
  </div>

  <!-- <div id="g_id_onload" data-client_id="306399346139-snsajbsqgf2dc48eeptm1ir0v94k00hi.apps.googleusercontent.com"
    data-callback="handleCredentialResponse" data-auto_prompt="false">
  </div>
  
  <div class="g_id_signin" data-type="standard" data-size="large" data-theme="outline" data-text="signup_with"
    data-shape="rectangular" data-logo_alignment="left">
  </div> -->
  <!-- <div id="registerGoogle"></div> -->

  <!-- <button class="btn btn-secondary w-100 mb-3" (click)="signInWithFB()"><i-feather name="facebook" class="small"></i-feather> {{ 'Regístrate con Facebook' | translate}}</button> -->
  <!-- <button class="btn btn-secondary w-100" (click)="signInWithGoogle()"><i-feather name="google" class="small"></i-feather> {{ 'Regístrate con Google' | translate}}</button> -->
  <div class="divider-or my-4">
    <span>o</span>
    <hr />
  </div>
  <form [formGroup]="userForm" class="pb-5">
    <!-- Step 1 -->

    <div *ngIf="currentStep === 1">
      <form [formGroup]="userForm" (ngSubmit)="goToNextStep()">
        <div class="row">
          <div class="col-12 form-group">
            <label>
              {{ "Nombre comercial" | translate }}
              <span class="form-required text-danger">*</span>
            </label>
            <input
              [placeholder]="translate.instant('Nombre empresa u organizador')"
              type="text"
              class="form-control"
              formControlName="name"
            />
            <small class="text-danger" *ngIf="showError(userForm, 'name')">
              {{ translate.instant(errors["makerName"]) }}
            </small>
          </div>
        </div>

        <div class="row">
          <!-- <div class="col-md-4 form-group">
        <label>
          {{ 'Nº experiencias' | translate }}
          <span class="form-required text-danger">*</span>
        </label>
        <input 
          type="number" 
          min="0"
          max="15"
          class="form-control" 
          formControlName="experienceCount">
        <small class="text-danger" *ngIf="showError(makerForm, 'experienceCount')">
          {{ translate.instant(errors['experienceCount']) }}
        </small>
      </div> -->

          <div class="col-md-6 form-group">
            <label>
              {{ "Localidad" | translate }}
              <span class="form-required text-danger">*</span>
            </label>
            <ng-select
              [placeholder]="translate.instant('Seleccionar la localidad')"
              aria-label="Location"
              formControlName="location"
              required
            >
              <ng-option
                *ngFor="let location of locations"
                [value]="location['@id']"
              >
                {{ location.name }}
              </ng-option>
            </ng-select>
            <small
              class="text-danger"
              *ngIf="showError(userForm, 'location')"
            ></small>
          </div>

          <div class="col-md-6 form-group">
            <label>
              {{ "Motor de reservas" | translate }}
              <span class="form-required text-danger">*</span>
            </label>
            <ng-select
              [placeholder]="translate.instant('Seleccionar motor de reservas')"
              formControlName="bookingEngine"
            >
              <ng-option value="Turitop">Turitop</ng-option>
              <ng-option value="Fareharbor">Fareharbor</ng-option>
              <ng-option value="Bokun">Bokun</ng-option>
              <ng-option value="Propio">Sistema propio</ng-option>
              <ng-option value="Others">Otros</ng-option>
            </ng-select>
            <small
              class="text-danger"
              *ngIf="showError(userForm, 'bookingEngine')"
            ></small>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 form-group">
            <label>
              {{ "Página web" | translate }}
              <span class="form-required text-danger">*</span>
            </label>
            <input
              [placeholder]="translate.instant('Página web')"
              type="text"
              class="form-control"
              formControlName="web"
            />
            <small class="text-danger" *ngIf="showError(userForm, 'web')">
              {{ translate.instant(errors["makerWeb"]) }}
            </small>
          </div>
        </div>

        <!-- Next Button -->
        <button type="submit" class="btn btn-primary mt-3">
          {{ "Next" | translate }}
        </button>
      </form>
    </div>

    <!-- Step 2 -->

    <div *ngIf="currentStep === 2" class="container-fluid">
      <h3>{{ "Paso 2: Información Adicional" | translate }}</h3>
      <form [formGroup]="makerForm" (ngSubmit)="submitStepTwo()">
        <div class="row">
          <div class="col form-group">
            <label
              >{{ "Denominación social" | translate }}
              <span class="form-required text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              formControlName="companyName"
              [placeholder]="translate.instant('Denominación social')"
            />
            <small
              class="text-danger"
              *ngIf="showError(makerForm, 'companyName')"
            >
              {{ translate.instant(errors["companyName"]) }}
            </small>
          </div>
        </div>

        <!-- Document type and number -->
        <div class="row">
          <div class="col-md-6 form-group">
            <label
              >{{ "Tipo de documento" | translate }}
              <span class="form-required text-danger">*</span></label
            >
            <ng-select
              [placeholder]="translate.instant('Seleccionar tipo de documento')"
              formControlName="documentType"
              [(ngModel)]="documentTypeSelected"
            >
              <ng-option
                [value]="documentType"
                *ngFor="let documentType of documentTypes"
                >{{ documentType }}</ng-option
              >
            </ng-select>
            <small
              class="text-danger"
              *ngIf="showError(makerForm, 'documentType')"
            >
              {{ translate.instant(errors["documentType"]) }}
            </small>
          </div>

          <div class="col-md-6 form-group">
            <label
              >{{ "Número de Documento" | translate }}
              <span class="form-required text-danger">*</span></label
            >
            <input
              [placeholder]="translate.instant('Documento')"
              type="text"
              class="form-control"
              formControlName="document"
            />
            <small class="text-danger" *ngIf="showError(makerForm, 'document')">
              {{ translate.instant(errors["document"]) }}
            </small>
          </div>
        </div>

        <!-- Name and surname -->
        <div class="row">
          <div class="col-md-6 form-group">
            <label
              >{{ "Nombre de contacto" | translate }}
              <span class="form-required text-danger">*</span></label
            >
            <input
              [placeholder]="translate.instant('Nombre de contacto')"
              type="text"
              class="form-control"
              formControlName="contactName"
            />
            <small
              class="text-danger"
              *ngIf="showError(makerForm, 'contactName')"
            >
              {{ translate.instant(errors["contactName"]) }}
            </small>
          </div>

          <div class="col-md-6 form-group">
            <label
              >{{ "Apellido de contacto" | translate }}
              <span class="form-required text-danger">*</span></label
            >
            <input
              [placeholder]="translate.instant('Apellido de contacto')"
              type="text"
              class="form-control"
              formControlName="contactLastname"
            />
            <small
              class="text-danger"
              *ngIf="showError(makerForm, 'contactLastname')"
            >
              {{ translate.instant(errors["contactLastname"]) }}
            </small>
          </div>
        </div>

        <div class="form-group">
          <input
            type="email"
            name="email"
            formControlName="email"
            [placeholder]="translate.instant('Correo electrónico') + '*'"
            class="form-control"
          />
          <small class="text-danger" *ngIf="showError(makerForm, 'email')">
            {{ translate.instant(errors["email"]) }}
          </small>
        </div>
        <div class="form-group">
          <input
            type="password"
            passToggle
            maxlength="15"
            name="password"
            formControlName="password"
            [placeholder]="translate.instant('Contraseña') + '*'"
            class="form-control"
          />
          <small class="text-danger" *ngIf="showError(makerForm, 'password')">
            {{ translate.instant(errors["password"]) }}
          </small>
        </div>
        <!-- <h5 class="font-weight-bold">¿Qué tipo de usuario eres?</h5>
    <div class="form-group custom-control custom-radio mb-1">
      <input class="custom-control-input" type="radio" id="taker" formControlName="role" value="ROLE_TAKER" name="role" checked>
      <label class="custom-control-label d-block" for="taker">
        <span class="icon"></span>
        <span class="text">Taker</span>
        <i-feather name="help-circle" class="small ml-1 text-muted" tooltip="Los que disfrutan de las experiencias" placement="right"></i-feather>
      </label>
    </div>
    <div class="form-group custom-control custom-radio">
      <input class="custom-control-input" type="radio" id="maker" formControlName="role" value="ROLE_MAKER" name="role">
      <label class="custom-control-label d-block" for="maker">
        <span class="icon"></span>
        <span class="text">Maker</span>
        <i-feather name="help-circle" class="small ml-1 text-muted" tooltip="Los que organizan las experiencias" placement="right"></i-feather>
      </label>
    </div>
    <small class="text-danger" *ngIf="showError(makerForm, 'role')">
      {{errors['role']}}
    </small> -->

        <!-- Subscription Checkbox -->
        <div class="form-group custom-control custom-checkbox mb-4">
          <input
            type="checkbox"
            class="custom-control-input"
            id="subscription"
            formControlName="subscription"
          />
          <label class="custom-control-label" for="subscription">
            {{ "¿Quieres recibir información útil?" | translate }}
          </label>
        </div>

        <p class="small text-muted">
          {{ "Al Hacer clic en “Crear cuenta” aceptas nuestras" | translate }}
          <a
            class="text-dark"
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            >{{ "Condiciones de uso" | translate }}</a
          >,
          <a
            class="text-dark"
            href="https://pro.venntur.com/politica-de-privacidad/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ "Política de privacidad" | translate }}</a
          >
          {{ "y la" | translate }}
          <a
            class="text-dark"
            href="https://pro.venntur.com/politica-de-cookies/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ "Política de cookies" | translate }}</a
          >.
        </p>
        <button
          class="btn btn-primary w-100"
          type="submit"
          name="button"
          [disabled]="makerForm.invalid"
        >
          {{ "Create Account" | translate }}
        </button>
      </form>

      <!-- Create a button that your customers click to complete their purchase. Customize the styling to suit your branding. -->
      <!--  <button-->
      <!--    style="background-color:#6772E5;color:#FFF;padding:8px 12px;border:0;border-radius:4px;font-size:1em"-->
      <!--    id="checkout-button-price_1HtuT8DQOX9k1ARpo2xGkQpJ"-->
      <!--    role="link"-->
      <!--    type="button"-->
      <!--    (click)="test()"-->
      <!--  >-->
      <!--    Checkout-->
      <!--  </button>-->

      <div class="mt-4" *ngIf="alert.message">
        <p
          class="alert"
          [class.alert-success]="alert.type == 1"
          [class.alert-danger]="alert.type == 2"
        >
          {{ alert.message }}
        </p>
      </div>
    </div>
  </form>
</div>
